package com.macrofocus.eflux.animation

import com.macrofocus.eflux.diagram.DiagramType

data class Playback(val timeline: Timeline, val diagramType: DiagramType) {
}